import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.ai.chat');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-component-ai-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.ai.chat/view.scss */
:host {
  display: contents;
}

.chat-bubble-enter {
  animation: bubbleSlideIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes bubbleSlideIn {
  0% {
    opacity: 0;
    transform: translateX(12px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.ai-chat-markdown h3, .ai-chat-markdown h4 {
  font-weight: 600;
  margin: 4px 0 2px;
}
.ai-chat-markdown h3 {
  font-size: 13px;
}
.ai-chat-markdown h4 {
  font-size: 12px;
}
.ai-chat-markdown strong {
  font-weight: 600;
}
.ai-chat-markdown code {
  background: rgba(0, 0, 0, 0.06);
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 11px;
}
.ai-chat-markdown ul {
  padding-left: 14px;
  margin: 2px 0;
}
.ai-chat-markdown ul li {
  list-style: disc;
  margin: 1px 0;
}
.ai-chat-markdown br + br {
  display: none;
}`],
})
export class ComponentAiChatComponent implements OnInit, OnDestroy {
    @ViewChild('chatBody') chatBody: ElementRef;
    @ViewChild('chatTextarea') chatTextarea: ElementRef;

    public open: boolean = false;
    public messages: any[] = [];
    public input: string = '';
    public loading: boolean = false;
    public collections: any[] = [];
    public scope: string = 'all';
    public hidden: boolean = false;
    public currentPage: string = '';
    public examples: string[] = [];

    public showBubble: boolean = false;
    private bubbleTimer: any = null;
    private bubbleHideTimer: any = null;
    private bubbleMessages: string[] = [
        '궁금한 점이 있으면 질문하세요!',
        '사이트 이용 중 도움이 필요하신가요?',
        'AI에게 무엇이든 물어보세요 😊',
        '자료 검색이나 사용법을 도와드릴게요',
        '클릭 한 번으로 AI 도움을 받으세요!'
    ];
    public bubbleText: string = '';

    private abortController: AbortController | null = null;
    private routerSub: Subscription;

    private pageExamples: any = {
        '/': [
            '이 사이트는 뭐하는 곳이야?',
            '자료함을 어떻게 만들어?',
            '시작하려면 뭘 해야 해?'
        ],
        '/collections': [
            '자료함은 왜 만들어야 해?',
            '태그는 어떻게 활용하나요?',
            'PDF 업로드는 어떻게 하나요?'
        ],
        '/members': [
            '멤버를 어떻게 초대하나요?',
            '역할(관리자/일반)의 차이는?',
            '멤버 권한 관리 방법을 알려줘'
        ],
        'default': [
            '이 사이트는 어떻게 사용하나요?',
            '자료 등록 방법을 알려줘',
            'AI 질문 기능은 어떻게 써?'
        ]
    };

    private pageNames: any = {
        '/': '대시보드',
        '/collections': '자료함 목록',
        '/members': '멤버 관리',
        '/mypage': '마이페이지'
    };

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.checkRoute();
        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.checkRoute();
            }
        });
        this.startBubbleTimer();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.abortController) this.abortController.abort();
        this.clearBubbleTimers();
    }

    private startBubbleTimer() {
        this.clearBubbleTimers();
        // 최초 30초 후 첫 말풍선, 이후 5분마다 반복
        this.bubbleTimer = setTimeout(() => {
            this.showBubbleMessage();
            this.bubbleTimer = setInterval(() => {
                this.showBubbleMessage();
            }, 5 * 60 * 1000);
        }, 30 * 1000);
    }

    private async showBubbleMessage() {
        if (this.open || this.hidden) return;
        const idx = Math.floor(Math.random() * this.bubbleMessages.length);
        this.bubbleText = this.bubbleMessages[idx];
        this.showBubble = true;
        await this.service.render();

        // 8초 후 자동 숨김
        if (this.bubbleHideTimer) clearTimeout(this.bubbleHideTimer);
        this.bubbleHideTimer = setTimeout(async () => {
            this.showBubble = false;
            await this.service.render();
        }, 8000);
    }

    public async dismissBubble() {
        this.showBubble = false;
        if (this.bubbleHideTimer) clearTimeout(this.bubbleHideTimer);
        await this.service.render();
    }

    private clearBubbleTimers() {
        if (this.bubbleTimer) {
            clearTimeout(this.bubbleTimer);
            clearInterval(this.bubbleTimer);
            this.bubbleTimer = null;
        }
        if (this.bubbleHideTimer) {
            clearTimeout(this.bubbleHideTimer);
            this.bubbleHideTimer = null;
        }
    }

    private async checkRoute() {
        const url = this.router.url.split('?')[0];
        this.hidden = url.startsWith('/chat') || url.startsWith('/graph');
        this.currentPage = url;
        this.examples = this.pageExamples[url] || this.pageExamples['default'];
        if (this.hidden) {
            this.showBubble = false;
        }
        await this.service.render();
    }

    private getPageContext(): string {
        const url = this.currentPage;
        const name = this.pageNames[url];
        if (name) return `사용자가 현재 "${name}" 페이지에 있습니다. (${url})`;
        if (url.startsWith('/collections/')) return `사용자가 현재 "자료함 상세" 페이지에 있습니다. (${url})`;
        return `사용자가 현재 ${url} 페이지에 있습니다.`;
    }

    public async toggle() {
        this.open = !this.open;
        this.showBubble = false;
        if (this.bubbleHideTimer) clearTimeout(this.bubbleHideTimer);
        if (this.open && this.collections.length === 0) {
            await this.loadCollections();
        }
        await this.service.render();
        if (this.open) this.scrollToBottom();
    }

    public async close() {
        this.open = false;
        await this.service.render();
    }

    private async loadCollections() {
        try {
            const res = await wiz.call("collections");
            if (res.code === 200) {
                this.collections = res.data.collections || [];
            }
        } catch (e) { }
    }

    public async selectScope(id: string) {
        this.scope = id;
        await this.service.render();
    }

    public getScopeLabel(): string {
        if (this.scope === 'all') return '전체 자료';
        const col = this.collections.find((c: any) => c.id === this.scope);
        return col ? col.title : '전체 자료';
    }

    public async useExample(q: string) {
        this.input = q;
        await this.send();
    }

    public async send() {
        const query = this.input?.trim();
        if (!query || this.loading) return;

        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }

        this.messages.push({ role: 'user', content: query });
        this.input = '';
        this.loading = true;
        if (this.chatTextarea) {
            this.chatTextarea.nativeElement.style.height = 'auto';
        }
        await this.service.render();
        this.scrollToBottom();

        const assistantMsg: any = { role: 'assistant', content: '', streaming: true };
        this.messages.push(assistantMsg);
        await this.service.render();

        const abortController = new AbortController();
        this.abortController = abortController;

        try {
            const formData = new FormData();
            formData.append('query', query);
            formData.append('scope', this.scope);
            formData.append('page', this.getPageContext());

            const response = await fetch('/wiz/api/component.ai.chat/stream_ask', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
                signal: abortController.signal
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let fullContent = '';
            let lastRender = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const parts = buffer.split('\n\n');
                buffer = parts.pop() || '';

                for (const part of parts) {
                    if (!part.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(part.slice(6));
                        if (event.type === 'token') {
                            fullContent += event.token;
                            assistantMsg.content = fullContent;
                        } else if (event.type === 'done') {
                            assistantMsg.streaming = false;
                        } else if (event.type === 'error') {
                            assistantMsg.streaming = false;
                            assistantMsg.content = event.message || '오류가 발생했습니다.';
                        }
                    } catch (e) { }
                }

                const now = Date.now();
                if (now - lastRender > 80) {
                    lastRender = now;
                    await this.service.render();
                    this.scrollToBottom();
                }
            }

            if (buffer.startsWith('data: ')) {
                try {
                    const event = JSON.parse(buffer.slice(6));
                    if (event.type === 'token') {
                        fullContent += event.token;
                        assistantMsg.content = fullContent;
                    }
                } catch (e) { }
            }

            assistantMsg.streaming = false;
            if (!assistantMsg.content) {
                assistantMsg.content = '답변을 생성할 수 없습니다.';
            }
            assistantMsg.html = this.renderMd(assistantMsg.content);
        } catch (e: any) {
            assistantMsg.streaming = false;
            if (e?.name !== 'AbortError') {
                assistantMsg.content = assistantMsg.content || '응답을 가져올 수 없습니다.';
            }
            assistantMsg.html = this.renderMd(assistantMsg.content);
        } finally {
            if (this.abortController === abortController) this.abortController = null;
            this.loading = false;
            await this.service.render();
            this.scrollToBottom();
        }
    }

    public renderMd(text: string): string {
        if (!text) return '';
        let html = text
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/^### (.+)$/gm, '<h4>$1</h4>')
            .replace(/^## (.+)$/gm, '<h3>$1</h3>')
            .replace(/^# (.+)$/gm, '<h3>$1</h3>')
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/`([^`]+)`/g, '<code>$1</code>')
            .replace(/^- (.+)$/gm, '<li>$1</li>')
            .replace(/^(\d+)\. (.+)$/gm, '<li>$2</li>');
        html = html.replace(/(<li>.*?<\/li>\n?)+/g, (m) => '<ul>' + m + '</ul>');
        html = html.replace(/\n/g, '<br>');
        return html;
    }

    public async onKeydown(event: any) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            await this.send();
        }
    }

    public autoResize() {
        if (!this.chatTextarea) return;
        const el = this.chatTextarea.nativeElement;
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 100) + 'px';
    }

    public async clearChat() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
        this.messages = [];
        this.loading = false;
        await this.service.render();
    }

    private scrollToBottom() {
        setTimeout(() => {
            if (this.chatBody) {
                const el = this.chatBody.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }
}

export default ComponentAiChatComponent;